import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { BarInfo } from './models/IBarGuideInfo';

const barInfoService = {
  getBarInformationList(type?: number): Promise<CommonResponse<Array<BarInfo>>> {
    const url = `/bar-guide-info`;
    return axiosClient.get(url, { params: { type } });
  },
  deleteBarInformationList(params: Array<number>): Promise<CommonResponse<Array<BarInfo>>> {
    const url = `/bar-guide-info`;
    return axiosClient.delete(url, { data: params });
  },
  restoreBarInformationList(params: Array<number>): Promise<CommonResponse<Array<BarInfo>>> {
    const url = `/bar-guide-info`;
    return axiosClient.patch(url, params);
  },
  updateBarInformation(params: BarInfo): Promise<CommonResponse<Array<BarInfo>>> {
    const url = `/bar-guide-info`;
    return axiosClient.put(url, params);
  },
  addNewBarInformation(params: BarInfo): Promise<CommonResponse<Array<BarInfo>>> {
    const url = `/bar-guide-info`;
    return axiosClient.post(url, params);
  },
};

export default barInfoService;
